export default {"src":"/_next/static/media/flag-other.13753901.svg","height":17,"width":24,"blurWidth":0,"blurHeight":0};